// Query-intent helpers shared by the React route and the static prerender. Carrier-specific copy is
// added only after Search Console shows real demand; the default remains the existing programmatic
// page formula. Numbers always come from the generated carrier stats, never from hand-written copy.

/** @param {{name:string, slug:string}} c @param {number|string} year */
export function carrierPageTitle(c, year) {
  if (c.slug === 'msc') return 'MSC Schedules: Point-to-Point Sailings & Transit Times'
  return `${c.name} Sailing Schedule ${year}: Port-to-Port Transit & Reliability`
}

/**
 * @param {{name:string, slug:string, description:string}} c
 * @param {{sailings:number, lanes:number}|undefined} stats
 */
export function carrierPageDescription(c, stats) {
  if (c.slug === 'msc' && stats) {
    return `Search ${stats.sailings.toLocaleString('en-US')} MSC sailings across ${stats.lanes.toLocaleString('en-US')} port pairs. Compare vessel, voyage, ETD, ETA, transit time and observed reliability.`
  }
  return stats
    ? `${c.description} SchedulesMCP tracks ${stats.sailings.toLocaleString('en-US')} ${c.name} sailings across ${stats.lanes.toLocaleString('en-US')} lanes.`
    : c.description
}

/** @param {{name:string, slug:string}} c */
export function carrierPageHeading(c) {
  return c.slug === 'msc' ? 'MSC point-to-point sailing schedules' : `${c.name} sailing schedules`
}

/**
 * A short answer for high-impression schedule-intent queries. Null keeps the normal carrier page
 * unchanged. @param {{slug:string}} c @param {{sailings:number,lanes:number}|undefined} stats
 */
export function carrierScheduleAnswer(c, stats) {
  if (c.slug !== 'msc' || !stats) return null
  return `Search current MSC schedules by choosing an origin and destination in the Compare tool. SchedulesMCP currently tracks ${stats.sailings.toLocaleString('en-US')} forward MSC sailings across ${stats.lanes.toLocaleString('en-US')} port pairs, including vessel, voyage, service, ETD, ETA, and transit time where published. Results also compare MSC with other carriers and observed on-time arrival performance.`
}
